import * as React from 'react';
import * as PropTypes from 'prop-types';
import {InjectedTranslateProps, translate} from 'react-i18next';
import {FedopsLogger} from '../../utils/fedops-logger';
import {startTrackingFolds, stopTrackingFolds} from '../../utils/track-folds';
import Products from '../Products';
import Features from '../Features';
import IntroText from '../IntroText';
import Marketing from '../Marketing';
import FreeSite from '../FreeSite';
import Gallery from '../Gallery';
import Hero from '../Hero';
import {PrerenderReporter} from '../../utils/prerender-reporter';
import experiments from '../../utils/experiments';
import {biLogger, getOrigin, HP_VERSION} from '../../utils/bi-logger';
import {setLang} from '../../utils/ctaLinks';
import {i18n as I18n} from 'i18next';
import {Component} from '../../layout/Layout';
import {ExperimentsBag} from '@wix/wix-experiments';

const componentsMap = {
  IntroText,
  Hero,
  Products,
  Features,
  Marketing,
  FreeSite,
  Gallery
};

interface AppProps extends InjectedTranslateProps {
  staticsBaseUrl: string;
  fedopsLogger?: FedopsLogger;
  i18n?: I18n;
  layoutOrder: Component[];
  experiments: ExperimentsBag;
}

class App extends React.Component<AppProps> {
  private prerenderReporter: PrerenderReporter = new PrerenderReporter();
  static propTypes = {
    t: PropTypes.func
  };
  private componentUnmounted: boolean = false;

  constructor(props: AppProps) {
    super(props);
    setLang(props.i18n.language);
    experiments.add(props.experiments);
  }

  componentDidMount() {
    experiments.load('marketing-homepage').then(() => !this.componentUnmounted && this.forceUpdate());

    startTrackingFolds({
      timeOnFold: 3000,
      folds: document.querySelectorAll('.page-fold')
    });
    this.prerenderReporter.start();
    biLogger.getLogger('hp').hpFinishLoading({
      delta: Date.now() - window['wixHpLoadTime'],
      origin: getOrigin(),
      version: HP_VERSION
    });
    this.props.fedopsLogger && this.props.fedopsLogger.appLoaded();
  }

  componentWillUnmount() {
    stopTrackingFolds();
    this.componentUnmounted = true;
    this.prerenderReporter.stop();
  }

  render() {
    const {layoutOrder = []} = this.props;
    return layoutOrder.map(({type, props}) => React.createElement(componentsMap[type], props));
  }
}

export default translate()(App);
